import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundingDownPoints'
})
export class RoundingDownPointsPipe implements PipeTransform {

  transform(value: number): number {
    const result = value >= 0 ? Math.floor(value) : Math.ceil(value);
    return result || 0;
  }

}
